import * as React from "react";

interface MaskProps {
    zIndex?: number;
    backgroundColor?: string;
}

export default class Mask extends React.Component<MaskProps, {}> {

    static defaultProps = {
        zIndex: 2,
        backgroundColor: 'rgba(0,0,0,0.3)'
    };

    render() {
        const styles = this.getStyles();
        return (
            <div style={styles.root}>
                <div style={styles.center}>
                    {this.props.children}
                </div>
            </div>
        );
    }

    private getStyles() {
        return {
            root: {
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                backgroundColor: this.props.backgroundColor,
                zIndex: this.props.zIndex
            },
            center: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate3d(-50%, -50%, 0)'
            }
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/Mask.tsx
 **/